/* @flow */
import React from 'react';
import { Container } from 'flux/utils';
import PendingConnectedBankAccountRequestsModal from 'payments/components/PendingConnectedBankAccountRequestsModal.jsx';
import ConnectedBankAccountActions from 'payments/actions/ConnectedBankAccountActions';
import ConnectedBankAccountStore from 'payments/stores/ConnectedBankAccountStore';
import ConnectedBankAccount from 'entities/ConnectedBankAccount';

type State = {
  pendingBankAccountRequests: ConnectedBankAccount[],
};

class PendingConnectedBankAccountRequestsModalContainer extends React.Component {
  state: State;

  static getStores() {
    return [
      ConnectedBankAccountStore,
    ];
  }

  static calculateState() {
    const pendingBankAccountRequests = ConnectedBankAccountStore.getConnectedBankAccounts().filter(
      account => account.getCanManage() && account.isPending()
    );

    return { pendingBankAccountRequests };
  }

  componentDidMount() {
    ConnectedBankAccountActions.load();
  }

  render() {
    return (
      <PendingConnectedBankAccountRequestsModal
        {...this.props} /* all the inject modal props */
        refreshPendingBankAccountRequests={ConnectedBankAccountActions.load}
        pendingBankAccountRequests={this.state.pendingBankAccountRequests}
      />
    );
  }
}

export default Container.create(PendingConnectedBankAccountRequestsModalContainer, { withProps: true });



// WEBPACK FOOTER //
// ./src/payments/containers/PendingConnectedBankAccountRequestsModalContainer.jsx